import { OfferScheme, Uom } from "./headerParametersValues.model";

export class EndsCondition {
    value?: string;
    isDefault?: boolean;
}

export class TestCondition {
    value?: string;
    isDefault?: boolean;
}

export class Ht {
    value?: boolean;
    isDefault?: boolean;
}

export class HtAdditional {
    value?: boolean;
    isDefault?: boolean;
}

export class HydroTest {
    value?: boolean;
    isDefault?: boolean;
}

export class UomsType {
    metricUoms?: Uom[];
    imperialUoms?: Uom[];
}

export class InspectionType3Dot2 {
    value?: boolean;
    isDefault?: boolean;
}

export class LengthType {
    value?: string;
    isDefault?: boolean;
}

export class Mill {
    millId?: number;
    name?: string;
    shortName?: string;
    city?: string;
    country?: string;
}

export class MultipleCutting {
    value?: boolean;
    isDefault?: boolean;
}

export class ItemSms {
    smsId?: number;
    name?: string;
    description?: string;
    marketingRoute?: string;
}

export class SurfaceTypes {
    surfaceTypeId?: number;
    name?: string;
    description?: string;
}

export class TypeOfTolerance {
    value?: string;
    isDefault?: boolean;
}

export class Ut {
    value?: boolean;
    isDefault?: boolean;
}

export class MarketFamily {
    description?: string;
    isDefaultForStock?: boolean;
    isDefaultForProject?: boolean;
    marketFamilyId?: number;
    name?: string;
}

export class TubeExecution {
    description?: string;
    isCustom?: boolean;
    isDefaultForCold?: boolean;
    isDefaultForHot?: boolean;
    name?: string;
    toleranceMinusAw?: number;
    toleranceMinusMw?: number;
    tolerancePlusAw?: number;
    tolerancePlusMw?: number;
    tubeExecutionId?: number;
    marketingRoute?: string;
}

export class Sql {
    sqlId?: number;
    name?: string;
    isDefault?: boolean;
}

export class ItemParametersValues {
    endsCondition?: EndsCondition[];
    ht?: Ht[];
    testCondition?: TestCondition[];
    htAdditional?: HtAdditional[];
    hydroTest?: HydroTest[];
    idUoms?: UomsType;
    inspectionType3dot2?: InspectionType3Dot2[];
    lengthType?: LengthType[];
    lengthUoms?: UomsType;
    mills?: Mill[];
    multipleCutting?: MultipleCutting[];
    odUoms?: UomsType;
    quantityUoms?: UomsType;
    sms?: ItemSms[];
    surfaceTypes?: SurfaceTypes[];
    totalWeightUoms?: UomsType;
    typeOfTolerance?: TypeOfTolerance[];
    ut?: Ut[];
    wtUoms?: UomsType;
    marketFamily?: MarketFamily[];
    tubeExecution?: TubeExecution[];
    sqls?: Sql[];
    offerSchemes?: OfferScheme[];
}